module.exports = __webpack_public_path__ + "media/images/flags/CV-2cef9fc66e9dea4cd686e3ccb2144a39.svg";